"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FavoriteBorderIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4.91501C13.09 3.63501 14.76 2.82501 16.5 2.82501C19.58 2.82501 22 5.24501 22 8.32501C22 12.1019 18.6056 15.18 13.4627 19.8435L13.45 19.855L12 21.175L10.55 19.865L10.5105 19.8291C5.38263 15.1693 2 12.0953 2 8.32501C2 5.24501 4.42 2.82501 7.5 2.82501C9.24 2.82501 10.91 3.63501 12 4.91501ZM12 18.475L12.1 18.375C16.86 14.065 20 11.215 20 8.32501C20 6.32501 18.5 4.82501 16.5 4.82501C14.96 4.82501 13.46 5.81501 12.94 7.18501H11.07C10.54 5.81501 9.04 4.82501 7.5 4.82501C5.5 4.82501 4 6.32501 4 8.32501C4 11.215 7.14 14.065 11.9 18.375L12 18.475Z",
  fill: "currentColor"
}));

var _default = FavoriteBorderIcon;
exports.default = _default;